import {
  gnnodeNameIsValid,
  gnnodeKeyIsValid,
  gnnodeChildKeysGet as nodeChildKeysGet,
  gnnodeChildKeysDOMElemMv as nodeChildKeysDOMElemMv,
  gnnodeChildKeysElemMv as nodeChildKeysElemMv,
  gnnodeChildKeyCreate as nodeChildKeyCreate,
  gnnodeCreateFromSpec as nodeCreateFromSpec
} from './gnnode.js'

import {
  gnpathRelResolve as pathRelResolve
} from './gnpath.js'

import {
  gngraphNodeRm as graphNodeRm,
  gngraphNodeEdgeSet as graphNodeEdgeSet,
  gngraphNodeChildSet as graphNodeChildSet,
  gngraphNodeDFSApply as utilgraphNodeDFSApply,
  gngraphNodeSet as graphNodeSet,
  gngraphNodeRootGet as graphNodeRootGet
} from './gngraph.js'

import {
  gnaccNSMap as accNSMap,
  gnaccCache as accCache,
  gnaccFKey as accFKey,
  gnaccInit as accInit,
  gnaccFull as accFull,
  gnaccSubj as accSubj,
  gnaccSuch as accSuch,
  gnaccBase as accBase,
  gnaccBaseElem as accBaseElem
} from './gnacc.js'

import {
  gnarrReduceTuple as arrReduceTuple,
  gnarrReduce as arrReduce
} from './gnarr.js'

import {
  gnspecClientIs as specClientIs,
  gnspecClientNSREFIs as specClientNSREFIs,
  gnspecClientNSREFNTHIs as specClientNSREFNTHIs,
  gnspecClientNSREFNTHARG as specClientNSREFNTHARG,
  gnspecClientNSOBJGet as specClientNSOBJGet,
  gnspec_clientis,
  gnspec_ischildsfold,
  gnspec_recnsrefresolve,
  gnspec_childrefget,
  gnspec_nspropexpand,
  gnspec_traitresolve,
  gnspec_childprefromspec,
  gnspec_traitisexternal,
  gnspec_childprefkeyfromdatakey
} from './gnspec.js'

import {
  gnreportCreate as reportCreate,
  gnreportMarkNodeRemovalComplete as reportMarkNodeRemovalComplete,
  gnreportMarkNodeHydrationComplete as reportMarkNodeHydrationComplete
} from './gnreport.js'

import {
  gnerr_nodechildnameinvalid,
  gnerr_nodespecnameinvalid,
  gnerrNodexNotFound,
  gnerr_nodeonsubjmustboolean,
  gnerr_nodespecchildinvalid,
  gnerrnode_childspecnotfound,
  gnerrnode_foreignnamespacenotfound,
  gnerrnode_edgenodenotfound,
  gnerr_nodenotfound,
  gnerrNodeNSBaseMustResolveToArr as errNodeNSBaseMustResolveToArr
} from './gnerr.js'

import {
  gnenumKEY as KEY,
  gnenumNAME as NAME,
  gnenumSPEC as SPEC,
  gnenumNODE as NODE,
  gnenumTYPE as TYPE,
  gnenumCHILD as CHILD,
  gnenumCHILDKEYS as CHILDKEYS,
  gnenumCHILDKEYSDOM as CHILDKEYSDOM,

  gnenumNSFULL as NSFULL,
  gnenumNSSUBJ as NSSUBJ,
  gnenumNSINIT as NSINIT,
  gnenumNSSUCH as NSSUCH,
  gnenumNSFKEY as NSFKEY,

  gnenumXINIT as XINIT,
  gnenumXVNODE as XVNODE,
  gnenumXRESET as XRESET,
  gnenumXONSUBJ as XONSUBJ,
  gnenumXONFRAME as XONFRAME,
  gnenumXONATTACH as XONATTACH,
  gnenumXONCHILDADD as XONCHILDADD,
  gnenumXONCHILDREMOVE as XONCHILDREMOVE,
  gnenumXHYDRATEDBASE as XHYDRATEDBASE,
  gnenumXHYDRATEDSUBJ as XHYDRATEDSUBJ,

  gnenumSPECNODENAMEKEY as SPECNODENAMEKEY,
  gnenumSPECNODETYPES as SPECNODETYPES,
  gnenumNSFKEYBASEELEM as NSFKEYBASEELEM,
  gnenumONFRAMEKEYMAP as ONFRAMEKEYMAP,
  gnenumONFRAMEKEYLIST as ONFRAMEKEYLIST,
  gnenumNSSUBJCLASSNAMEROOT as NSSUBJCLASSNAMEROOT,
  gnenumNSSUBJMETATITLE as NSSUBJMETATITLE,
  gnenumNSSUBJMETADESCRIPTION as NSSUBJMETADESCRIPTION
} from './gnenum.js'

import {
  gnrun
} from './gnrun.js'

import {
  gnutilNonNullObjIs as utilNonNullObjIs,
  gnutilPlainObjIs as utilPlainObjIs,
  gnutilShallowCp as utilShallowCp
} from './gnutil.js'

const gnnodeosNSIsSupportEdge = ns => (
  [NSFULL, NSSUBJ, NSSUCH, NSFKEY].includes(ns))

const gnnodeosxGet = (cfg, gr, nd) => {
  const nodex = cfg.nodexmap[nd.get(NODE)]
  if (!nodex)
    throw gnerrNodexNotFound(gr, nd)

  return nodex
}

const gnnodeosMetaGet = nd => {
  const metatitle = accSubj.propget(nd, NSSUBJMETATITLE)
  const metadescription = accSubj.propget(nd, NSSUBJMETADESCRIPTION)

  return (metatitle || metadescription) && {
    metatitle,
    metadescription
  }
}

const gnnodeosxFnGet = (cfg, gr, nd, fnname) => {
  const nodevx = gnnodeosxGet(cfg, gr, nd)

  return nodevx && nodevx[fnname]
}

const gnnodeosCreateInit = (cfg, gr, data) => {
  if (!gnnodeNameIsValid(data.name))
    throw gnerr_nodespecnameinvalid(gr, null, data)

  const nd = nodeCreateFromSpec(data)
  const ndxinit = gnnodeosxFnGet(cfg, gr, nd, XINIT)

  return ndxinit ? ndxinit(nd) : nd
}

const gnnodeosxReset = (cfg, gr, nd) => (
  gnnodeosxFnGet(cfg, gr, nd, XRESET)(nd))

const gnnodeosChildGet = (gr, nd, name) => {
  if (!gnnodeNameIsValid(name)) {
    throw gnerr_nodechildnameinvalid(gr, nd, { name })
  }

  return gr.get(nodeChildKeyCreate(nd, name))
}

const gnnodeosChildSetFromSpec = (ss, cfg, gr, nd, ndx, childspec) => {
  let cnode = gnnodeosCreateInit(cfg, gr, childspec, nd)

  // copy fkey from parent to child
  if (accFKey.has(nd)) {
    cnode = accFKey.assign(cnode, accFKey.get(nd))
  }

  const res = graphNodeChildSet(
    gr, nd, cnode, cnode.get(SPECNODENAMEKEY, null))
  gr = res[0]
  nd = res[1]
  cnode = res[2]

  // return [gr, nd, cnode]
  return ndx[XONCHILDADD](ss, cfg, gr, nd, cnode)
}

// move node's last-child to ckeyindex and cdomkeyindex
//
// useful when removing a previous node's subtree and then placing a
// new node subtree at the position of previous subtree
const gnnodeosChildKeyMv = (nd, ckeyindex, cdomkeyindex) => (
  nd = nodeChildKeysDOMElemMv(nd, cdomkeyindex),
  nd = nodeChildKeysElemMv(nd, ckeyindex),
  nd)

const gnnodeosPathResolve = (ss, cfg, gr, nd, opts) => {
  const pathopt = opts.path
  const pathlocal = pathopt
    && pathRelResolve(nd.get(KEY), pathopt)
  const pathforeign = !pathlocal && (opts.fnskey && opts.fnsprop
    && accNSMap[opts.fnskey].propget(nd, opts.fnsprop))
    || opts.fnspath
  const pathfull = pathlocal || pathforeign

  if (!gnnodeKeyIsValid(pathfull)) {
    throw gnerrnode_foreignnamespacenotfound(gr, nd, opts)
  }

  return pathfull
}

// `meta` MUST HAVE an explicitly defined path --not the case for 'spec'.
//
// spec may define abstract value such as 'userdata', unknown until runtime,
// but meta here must include the explicit path --the key to the userdata
const gnnodeosNSEdgeSetFromSpec = (ss, cfg, gr, ndtarget, nsname, spec) => {
  const chain = spec.chain
  const nsobj = specClientNSOBJGet(spec)
  const chainIsMutating = spec.chain.length > 1
  const path = gnnodeosPathResolve(ss, cfg, gr, ndtarget, nsobj)
  const ndsender = gr.get(path)

  if (!ndsender && !chain.some(rec => rec[0] === 'default'))
    throw gnerrnode_edgenodenotfound(gr, ndtarget, path, nsobj)

  if (ndsender) {
    const senderns = nsobj.nskey // || nsobj.fnskey
    const senderprop = nsobj.nsprop || nsobj.nsstr
    const edgesetres = graphNodeEdgeSet(gr,
      [ndsender, senderns, senderprop],
      [ndtarget, nsname, spec.name], {
        spec: chainIsMutating ? spec : null,
        COMPOSITEIDX: specClientNSREFNTHIs(spec)
          && Array.isArray(accNSMap[senderns].propget(ndsender, senderprop))
          && specClientNSREFNTHARG(spec)
      })

    gr = edgesetres[0]
    ndtarget = edgesetres[2]
  }

  return [gr, ndtarget]
}

const gnnodeosNSHydrateFromSpec = async (ss, cfg, gr, nd, nname, nspec, h) => {
  if (!specClientIs(nspec))
    return utilNonNullObjIs(nspec)
      ? [gr, nd, Object.assign({}, h, nspec)]
      : [gr, nd, h]

  if (specClientNSREFIs(nspec)) {
    const recnsrefspec = gnspec_recnsrefresolve(nspec.chain[0])

    if ((recnsrefspec.fnsstr || recnsrefspec.fnspath)
      && gnnodeosNSIsSupportEdge(recnsrefspec.nskey)
    ) {
      const res = gnnodeosNSEdgeSetFromSpec(ss, cfg, gr, nd, nname, nspec)

      gr = res[0]
      nd = res[1]
    }
  }

  const isaccum = gnspec_ischildsfold(nspec)
  if (isaccum) {
    // these are calculated (later) in child loop
    return [gr, nd, null]
  }

  const resolved = await gnrun(ss, cfg, gr, nd, {}, nspec)
  // ex,
  // ```
  // { 'gn:type': 'client', name: 'requrl', chain: [['getrequrl']] }
  // ```
  //
  // the result of `getrequrl` is assigned to named property `requrl`
  // ```
  // hydrated['requrl'] = '/blog/'
  // ```
  //
  // an exception is when the namespace itself is defined,
  // ```
  // { 'gn:type': 'client', name: 'base', chain: [['getusers']] }
  // ```
  const result = (NAME in nspec && nspec[NAME] !== nname)
    ? Object.assign({}, h, { [nspec[NAME]]: resolved })
    : resolved

  return [gr, nd, result]
}

const gnnodeosNSHydrateFromSpecArr = async (ss, cfg, gr, nd, nname, specs) => {
  if (!specs.length)
    return [gr, nd, null]

  if (!gnspec_clientis(specs.slice(-1)[0]))
    return [gr, nd, specs]

  return arrReduceTuple(specs, async (gr, nd, acc, spec) => (
    gnnodeosNSHydrateFromSpec(ss, cfg, gr, nd, nname, spec, acc)
  ), [gr, nd, {}])
}

// reason 'spec' is a param: callee may probe specget(nd) first
// to determnine if hydrate should be called. if so, pass spec
// in and reduce additional lookup for the same value
const gnnodeosNSHydrate = async (ss, cfg, gr, nd, accns, spec) => {
  const hydratespec = spec || accns.specget(nd)
  if (!hydratespec)
    return [gr, nd]

  const nsname = accns.getns()
  const hydratefn = Array.isArray(hydratespec)
    ? gnnodeosNSHydrateFromSpecArr
    : gnnodeosNSHydrateFromSpec

  // [gr, nd, result]
  return hydratefn(ss, cfg, gr, nd, nsname, hydratespec, {})
    .then(res => graphNodeSet(res[0], accns.assign(res[1], res[2])))
}

const gnnodeosNSHydratePost = async (ss, cfg, gr, nd) => {
  let res
  const ndx = gnnodeosxGet(cfg, gr, nd)
  const xhydratedbase = ndx[XHYDRATEDBASE]
  const xhydratedsubj = ndx[XHYDRATEDSUBJ]
  const fullSpec = accFull.specget(nd)
  const subjSpec = accSubj.specget(nd)

  if (xhydratedbase) {
    res = await xhydratedbase(ss, cfg, gr, nd, ndx)
    gr = res[0]
    nd = res[1]
  }

  if (fullSpec) {
    res = await gnnodeosNSHydrate(ss, cfg, gr, nd, accFull, fullSpec)
    gr = res[0]
    nd = res[1]
  }

  if (subjSpec) {
    res = await gnnodeosNSHydrate(ss, cfg, gr, nd, accSubj, subjSpec)
    gr = res[0]
    nd = res[1]
  }

  if (xhydratedsubj) {
    res = await xhydratedsubj(ss, cfg, gr, nd, ndx)
    gr = res[0]
    nd = res[1]
  }

  res = graphNodeSet(gr, nd)
  gr = res[0]
  nd = res[1]

  if (ndx[XONSUBJ])
    ndx.prevget(cfg, nd)

  return [gr, nd]
}

const gnnodeosNSHydratePre = async (ss, cfg, gr, nd, rep) => {
  // See note above `gnenumNSFKEYBASEELEM` definition
  let res
  const fkeybaseelems = accFKey.prophas(nd, NSFKEYBASEELEM)
    && accFKey.get(nd)
  const fkeySpec = accFKey.specget(nd)
  const initSpec = accInit.specget(nd)
  const baseElemSpec = accBaseElem.specget(nd)
  const baseSpec = accBase.specget(nd)

  if (fkeySpec) {
    res = await gnnodeosNSHydrate(ss, cfg, gr, nd, accFKey, fkeySpec)
    gr = res[0]
    nd = res[1]
  }

  if (fkeybaseelems) {
    nd = accFKey.assign(nd, fkeybaseelems)
  }

  if (initSpec) {
    res = await gnnodeosNSHydrate(ss, cfg, gr, nd, accInit, initSpec)
    gr = res[0]
    nd = res[1]
  }

  if (baseElemSpec) {
    res = await gnnodeosNSHydrate(ss, cfg, gr, nd, accBaseElem, baseElemSpec)
    gr = res[0]
    nd = res[1]
  }

  if (baseSpec) {
    res = await gnnodeosNSHydrate(ss, cfg, gr, nd, accBase, baseSpec)
    gr = res[0]
    nd = res[1]
  }

  return [gr, nd, rep]
}

const gnnodeosxVNodeGet = (ss, cfg, gr, nd, ndx, subj, ndvn) => (
  ndx = ndx || gnnodeosxGet(cfg, gr, nd),
  // note: 'subj' and 'prev' are synchronised when vnode is rerendered
  // ephemeral input values for things like text fields can remain
  // unchanged by vdom renders causing un-expected issues.
  //
  // for example, there a spec_fn "cleared" a text field by settings
  // its value to empty string "" and because prev held the initial
  // value of the as empty string "", when subj.value "" was published
  // to the component it was ignored because not different from prev
  // _each component include logic it needs to minimally 'diff' prev
  // to skip or 'onsubj' behaviours that are possibly expensive
  //
  // though different possible solutions, the goal at time of writing
  // is to avoid special-case logic at ephemeral-value components and
  // avoid tracking too many details.
  //
  // 'keyup' event used with text input at situation above triggered
  // rerender, which is probably unwise/expensive. this note to help
  // refresh about why this was done, for when further change is
  // needed later
  //
  // it might make sense for some components to 'synchronise' themselves
  // but leaving this as future problem to solve
  subj = ndx.prevset(cfg, nd, accSubj.get(nd, {})),
  ndvn = ndx[XVNODE](ss, cfg, gr, nd, ndx, subj),
  subj[NSSUBJCLASSNAMEROOT]
    && (ndvn.className += subj[NSSUBJCLASSNAMEROOT].replace(/\./g, ' ')),
  ndvn
)

const gnnodeosxVNodeGetFromKey = (ss, cfg, gr, ndkey) => {
  const nd = gr.get(ndkey)
  const ndx = nd && gnnodeosxGet(cfg, gr, nd)

  if (!nd)
    throw gnerr_nodenotfound(gr, ndkey)

  return gnnodeosxVNodeGet(ss, cfg, gr, nd, ndx)
}

const gnnode_childspecatom = (ss, cfg, gr, nd, refspec, spectypes) => {
  const childspecatom = refspec.spec || refspec

  if (typeof childspecatom === 'string') {
    return (spectypes || nd.get(SPECNODETYPES))[childspecatom]
  }

  return childspecatom
}

// refspec,
// { gn:type: 'local-ref',
//   path: '../root-data-child/eng-US.json' },
// { spec: "user" }
// { spec: { name: "label", node: "uilabel", child: [] } }
// { spec: "user",
//   specassign: {
//     onsubj: [{ 'gn:type': "fn", fnname: "cacheupdate", args: ["node"] }]
//   }
// }
const gnnodeosChildSpecFromRef = async (
  ss, cfg, gr, nd, refspec, spectypes
) => {
  const childspecatom = gnnode_childspecatom(
    ss, cfg, gr, nd, refspec, spectypes)
  const childspecfull = gnspec_traitisexternal(childspecatom)
    ? await gnspec_traitresolve(ss, cfg, childspecatom)
    : childspecatom

  if (!childspecfull) {
    throw gnerrnode_childspecnotfound(gr, nd, refspec, spectypes)
  }

  return refspec.specassign
    ? Object.assign({}, childspecfull, refspec.specassign)
    : childspecfull
}

const gnnodeosChildSpecFiltered = async (ss, cfg, gr, nd, spec) => {
  if (!spec.when)
    return null

  const errkey = await gnrun(ss, cfg, gr, nd, {}, spec.when)

  // TODO update/modify (hard, requires use-case/context)
  // was intended to return error messages that correspond to filter
  // result but behaviour may not be needed any longer
  return errkey === false || typeof errkey === 'string'
    ? errkey
    : null
}

// returns first child spec that passes filter from parent
const gnnodeosChildSpecWhenFirst = async (ss, cfg, gr, ndp, fkey, specs) => {
  return (async function next (x, specs, spec, props) {
    if (!x--) return null

    spec = specs[x]

    // ex, {"gn:type":"local-ref", path: "../to/eng.json"}
    if (gnspec_traitisexternal(spec)) {
      // this condition rarely used for prod deployments
      spec = await gnspec_traitresolve(ss, cfg, spec)
    }

    if (!spec.when) {
      if (spec[NSFKEY]) {
        spec = Object.assign({}, spec, {
          [accFKey.ns]: gnspec_childprefkeyfromdatakey(spec[NSFKEY], fkey)
        })
      }

      return spec
    }

    props = props || Object.assign({
      [NSINIT]: accInit.get(ndp, {}),
      ...(typeof fkey === 'string' && {
        [NSFKEY]: Object.assign({}, accFKey.get(ndp, {}),
          gnspec_childprefkeyfromdatakey(spec[NSFKEY], fkey))
      }),

      // why 'baseelem' added here? base frequently used in 'when' comparisons.
      // exact needed properties unknown until when clause processes them
      baseelem: typeof fkey === 'string'
        ? ({ [NSSUBJ]: accSubj.get(gr.get(fkey), {}) })
        : fkey
    })


    const ispass = await gnrun(
      ss, cfg, gr, ndp, props, spec.when)

    return ispass ? spec : next(x, specs, props)
  }(specs.length, specs))
}

const gnnodeosChildSpecResolveEachBase = async (
  ss, cfg, gr, nd, childspecs, onspecfn
) => {
  const spectypes = nd.get(SPECNODETYPES)
  const basearr = accBase.get(nd, [])

  if (!Array.isArray(basearr))
    throw errNodeNSBaseMustResolveToArr(gr, nd, basearr)

  return arrReduceTuple(basearr, async (gr, nd, acc, data, x) => {
    const childspec = await gnnodeosChildSpecWhenFirst(
      ss, cfg, gr, nd, data, childspecs)
    if (!childspec)
      return [gr, nd]

    const childspecatom = gnnode_childspecatom(
      ss, cfg, gr, nd, childspec, spectypes)
    const childspecfull = gnspec_traitisexternal(childspecatom)
      ? await gnspec_traitresolve(ss, cfg, childspecatom)
      : childspecatom
    const childspecfin = await gnspec_childprefromspec(
      ss, cfg, gr, nd, data, x, childspec, childspecfull)

    return onspecfn(gr, nd, childspecfin, x)
  }, [gr, nd, null])
}

// AN OLD NOTE BELOW
// if addressing this kludge see also
// gnspec_childrefget, which similarly
// delays usage of spec property when namekey is defined
const gnnode_specgetequip = spec => {
  const specobj = spec[SPECNODENAMEKEY] ? spec : spec[SPEC] || spec

  // copy 'specific' properties, which may be defined on 'spec', to a
  // ganeric resuable 'spec' definition a 'spec.spec'
  // ex, spec.name or spec.baseelem
  // copy baseelem, datakeyprop, name, etc...
  return (spec[SPEC] && spec.specassign)
    ? Object.assign({}, specobj, spec.specassign)
    : specobj
}

// spec may be a single item or a list
// processes each each item regardless of structure
//
// ex,
//
//   { when : { ... }
//     spec : { ... } }
//
//   { when : { ... }
//     spec : [{ ... }, { ... }] }
//
//   { ... }
//
//   [{ ... }, { ... }]
//
//
const gnnodeosChildSpecEach = (ss, cfg, gr, nd, spec, nextfn) => {
  const specobj = gnnode_specgetequip(spec)
  const specobjarr = Array.isArray(specobj) ? specobj : [specobj]

  return arrReduceTuple(specobjarr, async (gr, nd, _, specobj) => (
    nextfn(gr, nd, specobj)
  ), [gr, nd, null])
}

// mulitple addspecchild may blend childs to single parent node
const gnnodeosChildSpecResolve = async (
  ss, cfg, gr, nd, spec, cidx, onspec
) => {
  if (!utilPlainObjIs(spec)) {
    throw gnerr_nodespecchildinvalid(gr, nd, spec)
  }

  let errkey, res

  errkey = await gnnodeosChildSpecFiltered(ss, cfg, gr, nd, spec)

  if (errkey)
    return [gr, nd, cidx]

  res = await gnnodeosChildSpecEach(ss, cfg, gr, nd, spec, (
    async (gr, nd, spec) => {
      if (!utilPlainObjIs(spec))
        throw gnerr_nodespecchildinvalid(gr, nd, spec)

      spec = gnspec_traitisexternal(spec)
        ? await gnspec_traitresolve(ss, cfg, spec)
        : spec

      const childspec = gnspec_childrefget(spec, ++cidx)

      const resa = await onspec(gr, nd, childspec, cidx)

      // ;({ 0: gr, 1: nd } = resa)
      gr = resa[0]
      nd = resa[1]

      return [gr, nd]
      //onspec(gr, nd, childspec, cidx, fn)
    }))

  gr = res[0]
  nd = res[1]

  return [gr, nd, cidx]
  // fn(null, gr, nd, ndcnum)
}

// is ndcarr a 'node' or a 'spec'?
// resolves each child not base
const gnnodeosChildSpecResolveEachChild = async (
  ss, cfg, gr, nd, childspecs, onchildfn
) => {
  return arrReduceTuple(childspecs, async (gr, nd, count, spec) => (
    gnnodeosChildSpecResolve(
      ss, cfg, gr, nd, spec, count, onchildfn)
  ), [gr, nd, 0])
}

// recursive. deeply nested definitions for different types of collected data
// are flattened to one list. separate page objects can be used for separate
// lists
//
// if base, loop data|key list and map child spec to each
// else, loop child list as spec list

// conider the name...
// childspecseach OR
// specchildseach
const gnnodeosChildSpecResolveEach = async (ss, cfg, gr, nd, specs, nextfn) => {
  const resolveeachfn = (
    accBase.spechas(nd)
      ? gnnodeosChildSpecResolveEachBase
      : gnnodeosChildSpecResolveEachChild)

  return new Promise((resolve, error) => queueMicrotask(() => (
    resolveeachfn(ss, cfg, gr, nd, specs, nextfn)
      .then(res => resolve(res))
      .catch(e => error(e)))
  ))
}

// this function is to be called for each child hydrated
//
// creates child->parent edges and accumulates child-derived
// values persisted on parent, using accumulator functions
// described on the parent
//
// no "Great" way to do this. Setup is involved at each node and
// *all* 'such' patterns are looped and applied to the child.
//
// because this function must be called inside the child loop,
// post-child namespaces such as 'subj' and 'full' are unavailable
// from parent
const gnnodeosNSHydrateSuchFromChildsCreate = ndp => {
  const suchspec = accSuch.specget(ndp)
  if (!suchspec)
    return (ss, cfg, gr, nd, ndc) => [gr, nd, ndc]

  const suchspecarr = Array.isArray(suchspec) ? suchspec : [suchspec]

  // call function one time with no child
  // to set initial value
  return async (ss, cfg, gr, nd, ndc, ndcnum) => {
    if (ndc) {
      let res = graphNodeSet(
        gr, accFKey.propset(nd, CHILD, ndc.get(KEY)))
      gr = res[0]
      nd = res[1]
    }

    return arrReduceTuple(suchspecarr, async (gr, nd, ndc, spec) => {
      let res, h = {}
      const nsspec = gnspec_nspropexpand(spec)

      if (!nsspec.chain) {
        res = await gnnodeosNSHydrateFromSpec(
          ss, cfg, gr, nd, NSSUCH, spec, h)
        return [res[0], res[1], ndc]
      }

      const specfoldname = nsspec[NAME]
      const specfoldrec = nsspec.chain.find(rec => rec[0] === 'fold')
      const specfoldargs = specfoldrec[1]
      const specfoldstart = specfoldargs[0]
      const specfoldfnchain = specfoldargs[1]

      res = await gnnodeosNSHydrateFromSpec(
        ss, cfg, gr, nd, NSSUCH, spec, h)
      gr = res[0]
      nd = res[1]

      const prev = ndcnum === 0
        ? utilShallowCp(specfoldstart)
        : accSuch.propget(nd, specfoldname)

      const childfoldres = await gnrun(
        ss, cfg, gr, nd, {}, {
          [TYPE]: 'client',
          chain: [['childfold', [prev, ndc, ndcnum, specfoldfnchain]]]
        })

      res = graphNodeSet(
        gr, accSuch.propset(nd, specfoldname, childfoldres))

      return [res[0], res[1], ndc]
    }, [gr, nd, ndc])
  }
}

// TODO default vals should be pre-processed to JSON ahead of time,
// rather than being looped here
const gnnodeosHSHydrateSuchDefaults = (nd, suchspecarr) => {
  if (suchspecarr && suchspecarr.length) {
    nd = accSuch.set(nd, suchspecarr.reduce((acc, suchspec) => {
      if (gnspec_ischildsfold(suchspec)) {
        const specfoldname = suchspec[NAME]
        const specfoldrec = suchspec.chain.find(rec => rec[0] === 'fold')
        const specfoldargs = specfoldrec[1]
        const specfoldstart = specfoldargs[0]

        acc[specfoldname] = specfoldstart
      }

      return acc
    }, {}))
  }

  return nd
}

// tree traversal here is intentional. not as simple as basic dfs traversal...
//
// overall result is to hydrate all nodes w/ labels, fulldata/pooldata and
// child nodes to be used throughout this node's lifecycle
//
// just "downward" hydration is insufficient:
//   * prevents node from accessing child node data (most impactful for nodes
//     that manage lists of child nodes)
//
// just "upward" hydration insufficient:
//   * prevents node from generating dynamic node childs, child data is not
//     defined until too late to hydrate
//   * behaviour may be programmed into a node to rebuild itself using
//     traversal here and persisting the result back into graph
//
// this traversal enables dynamic lists... where the definition and total
// size of the node list may be unknown until processed at the parent.
// parent yields childs one at a time, allowing the parent to control the
// process through an async function redefinable by parent for special case.
// Each node is key'd, added to graph and then **traversed BEFORE next
// node is processed**. parent is configured to yield childs async so that
// any possible function is usable here,
//
//   1) DFS ENSURED, ensuring children are fully defined before parent,
//      enabling parent definition to read childs data and apply that
//      date to its own construction...
//
//   2) parent may yield childs in any way needed --from a list, a group of
//      lists, a single definition, a pattern etc. all defintions appear
//      'flatmapped' to parent (multiple lists appear joined as one)
//
//   3) parent has control to stop or continue or skip adding childs
//      ex, searchable and filterable list
//
// the callback and empty 'else' condition for forms that would obtain
// lists of data from an external node or service. assume this function
// can return an array of forms where caller is expected to recurse
// and return those here.
//
const gnnodeosHydrateDFS = async (ss, cfg, gr, nd, rep, res, bgnts) => {
  bgnts = bgnts || Date.now()
  nd = gnnodeosxFnGet(cfg, gr, nd, XINIT)(nd)

  res = await gnnodeosNSHydratePre(ss, cfg, gr, nd, rep)
  gr = res[0]
  nd = res[1]
  rep = res[2]

  const suchspecarr = accSuch.specget(nd, [])

  nd = gnnodeosHSHydrateSuchDefaults(nd, suchspecarr)

  const hydrateSuchFromChild =
    gnnodeosNSHydrateSuchFromChildsCreate(nd)

  // memoised to reduce lookups further down sequence
  // where each child is mounted in parent-specific way using ndx
  const ndx = gnnodeosxGet(cfg, gr, nd)
  const ndchildspecs = nd.get(CHILD, [])

  res = await gnnodeosChildSpecResolveEach(ss, cfg, gr, nd, ndchildspecs, (
    async (gr, nd, childspec, childnum) => {
      let res, ndc

      res = gnnodeosChildSetFromSpec(
        ss, cfg, gr, nd, ndx, childspec)
      ndc = res[2]
      gr = res[0]
      nd = res[1]

      res = await gnnodeosHydrateDFS(ss, cfg, gr, ndc, rep)

      gr = res[0]
      ndc = res[1]

      res = await hydrateSuchFromChild(ss, cfg, gr, nd, ndc, childnum)

      return [res[0], res[1]]
    }
  ))
  gr = res[0]
  nd = res[1]

  res = await gnnodeosNSHydratePost(ss, cfg, gr, nd)
  gr = res[0]
  nd = res[1]

  rep = reportMarkNodeHydrationComplete(rep, nd.get(KEY), bgnts)

  return [gr, nd, rep]
}

const gnnodeosRootHydrateDFS = async (ss, cfg, gr, isfresh) => {
  const ndroot = graphNodeRootGet(gr)
  const report = reportCreate('build')

  return isfresh
    ? gnnodeosHydrateDFS(ss, cfg, gr, ndroot, report)
    : [gr, ndroot, report]
}

// rebuild accumulator values...
const gnnodeosNSHydrateSuchFromChildsRefresh = async (ss, cfg, gr, nd) => {
  const pkey = nd.get(KEY)
  const hydrateSuchFromChild = gnnodeosNSHydrateSuchFromChildsCreate(nd)

  nd = gnnodeosHSHydrateSuchDefaults(nd, accSuch.specget(nd))

  return arrReduce(nodeChildKeysGet(nd), async (gr, ckey, i) => {
    const grnd = await hydrateSuchFromChild(
      ss, cfg, gr, gr.get(pkey), gr.get(ckey), i)

    return grnd[0]
  }, gr)
}

const gnnodeosxOnFrame = (ss, cfg, gr, nd) => {
  const ndx = nd && gnnodeosxGet(cfg, gr, nd)
  const ndxonframe = ndx && ndx[XONFRAME]

  ndxonframe && ndxonframe(
    ss, cfg, gr, nd, ndx, ndx.prevget(cfg, nd))
}

const gnnodeosRootNSCacheOnFrameKeyMapGet = gr => (
  accCache.propget(gr.get('/'), ONFRAMEKEYMAP, []))

const gnnodeosRootNSCacheOnFrameKeyMapSet = (gr, onframekeys) => (
  gr.set('/', accCache.assign(gr.get('/'), {
    [ONFRAMEKEYMAP]: onframekeys,
    [ONFRAMEKEYLIST]: Object.keys(onframekeys)
  })))

const gnnodeosRootNSCacheOnFrameKeysCall = (ss, cfg, gr) => {
  accCache.propget(gr.get('/'), ONFRAMEKEYLIST, [])
    .map(key => gnnodeosxOnFrame(ss, cfg, gr, gr.get(key)))
}

const gnnodeosxDetachDFS = (ss, cfg, gr, nd) => {
  const onframekeys = Object.assign(
    {}, gnnodeosRootNSCacheOnFrameKeyMapGet(gr))

  return utilgraphNodeDFSApply(ss, cfg, gr, nd, (gr, nd) => {
    const res = graphNodeRm(gr, nd)
    gr = res[0]
    nd = res[1]

    if (onframekeys[nd.get(KEY)])
      gr = gnnodeosRootNSCacheOnFrameKeyMapSet(gr, (
        delete onframekeys[nd.get(KEY)], onframekeys))

    return gr
  })
}

const gnnode_onattachtry = (ss, cfg, gr, nd, ndx) => {
  const ndxonattach = gnnodeosxFnGet(cfg, gr, nd, XONATTACH)

  ndxonattach && ndxonattach(
    ss, cfg, gr, nd, ndx, ndx.prevget(cfg, nd), accSubj.get(nd, {}))
}

// attaching events to specific node hierarchy
// specifically replace and attach this node to document
const gnnodeosxAttachDFS = (ss, cfg, gr, nd) => {
  const onframekeys = Object.assign({}, gnnodeosRootNSCacheOnFrameKeyMapGet(gr))

  gr = utilgraphNodeDFSApply(ss, cfg, gr, nd, (gr, nd) => {
    const ndx = gnnodeosxGet(cfg, gr, nd)

    if (typeof ndx[XONFRAME] === 'function')
      gr = gnnodeosRootNSCacheOnFrameKeyMapSet(gr, (
        onframekeys[nd.get(KEY)] = true, onframekeys))

    gnnode_onattachtry(ss, cfg, gr, nd, ndx)

    return gr
  })

  return gr
}

const gnnodeosRootxAttachDFS = (ss, cfg, gr) => (
  gnnodeosxAttachDFS(ss, cfg, gr, graphNodeRootGet(gr)))

const gnnodeosxDetachDFSChilds = (ss, cfg, gr, nd) => (
  nodeChildKeysGet(nd).reduce((gr, ckey/*, i*/) => (
    gnnodeosxDetachDFS(ss, cfg, gr, gr.get(ckey))
  ), gr))

const gnnodeosxAttachDFSChilds = (ss, cfg, gr, nd) => (
  nodeChildKeysGet(nd).reduce((gr, ckey/*, i*/) => (
    gnnodeosxAttachDFS(ss, cfg, gr, gr.get(ckey))
  ), gr))

const gnnodeosChildRm = (ss, cfg, gr, nd, ckey) => {
  const ndx = gnnodeosxGet(cfg, gr, nd)
  let res,
      ndc,
      childindex,
      domchildindex

  res = ndx[XONCHILDREMOVE](ss, cfg, gr, nd, ckey)
  gr = res[0]
  nd = res[1]

  ndc = gr.get(ckey)
  childindex = nd.get(CHILDKEYS).indexOf(ckey)
  domchildindex = nd.get(CHILDKEYSDOM).indexOf(ckey)
  gr = gnnodeosxDetachDFS(ss, cfg, gr, ndc)
  nd = gr.get(nd.get(KEY))
  // ^^ `ckey` detached from this graph --won't be found there

  return [gr, nd, ndc, childindex, domchildindex]
}

const gnnodeosChildRmAll = (ss, cfg, gr, nd) => {
  const nodekey = nd.get(KEY)

  return nodeChildKeysGet(nd).reduce((gr, ckey/*, i*/) => (
    gnnodeosChildRm(ss, cfg, gr, gr.get(nodekey), ckey)[0]), gr)
}

const gnnodeosRefreshDFS = async (ss, cfg, gr, nd, rep, bgnts) => {
  gr = gnnodeosxDetachDFSChilds(ss, cfg, gr, nd)
  rep = reportMarkNodeRemovalComplete(rep, nd.get(KEY), bgnts)

  const res = graphNodeSet(gr, gnnodeosxReset(cfg, gr, nd))
  gr = res[0]
  nd = res[1]

  return gnnodeosHydrateDFS(ss, cfg, gr, nd, rep)
}

// boolean indicates if call was accepted by the component
// if call was not accepted, and caller is patch function,
// caller may choose to apply update with rerender
const gnnodeosxOnSubj = async (ss, cfg, gr, nd) => {
  const ndx = nd && gnnodeosxGet(cfg, gr, nd)
  const ndxonsubj = ndx && ndx[XONSUBJ] || false
  const ndxonsubjres = ndxonsubj && await ndxonsubj(
    ss, cfg, gr, nd, ndx, ndx.prevget(cfg, nd), accSubj.get(nd, {}))

  if (typeof ndxonsubjres !== 'boolean')
    throw gnerr_nodeonsubjmustboolean(gr, nd, ndxonsubjres)

  return ndxonsubjres
}

export {
  gnnodeosMetaGet,
  gnnodeosCreateInit,
  gnnodeosxGet,
  gnnodeosxReset,
  gnnodeosxVNodeGet,
  gnnodeosxVNodeGetFromKey,
  gnnodeosxOnSubj,
  gnnodeosxOnFrame,
  gnnodeosxDetachDFS,
  gnnodeosxDetachDFSChilds,
  gnnodeosxAttachDFS,
  gnnodeosxAttachDFSChilds,

  gnnodeosPathResolve,

  gnnodeosChildKeyMv,
  gnnodeosChildGet,
  gnnodeosChildSetFromSpec,
  gnnodeosChildRm,
  gnnodeosChildRmAll,

  gnnodeosChildSpecEach,
  gnnodeosChildSpecFromRef,
  gnnodeosChildSpecFiltered,
  gnnodeosChildSpecWhenFirst,
  gnnodeosChildSpecResolve,
  gnnodeosChildSpecResolveEach,

  gnnodeosNSEdgeSetFromSpec,
  gnnodeosHSHydrateSuchDefaults,
  gnnodeosNSHydrateSuchFromChildsRefresh,
  gnnodeosNSHydrateSuchFromChildsCreate,
  gnnodeosNSHydrateFromSpecArr,
  gnnodeosNSHydrateFromSpec,
  gnnodeosNSHydratePost,
  gnnodeosNSHydratePre,
  gnnodeosNSHydrate,

  gnnodeosRootxAttachDFS,
  gnnodeosRootHydrateDFS,
  gnnodeosRootNSCacheOnFrameKeyMapGet,
  gnnodeosRootNSCacheOnFrameKeyMapSet,
  gnnodeosRootNSCacheOnFrameKeysCall,

  gnnodeosHydrateDFS,
  gnnodeosRefreshDFS
}

// attaching
// detaching
// specresolving
// hydrating
// refreshing
